// src/hooks/useClientAddresses.js
import { useState, useCallback } from "react";
import { useApi } from "./useApi";

/**
 * Hook para buscar endereços de um cliente pelo telefone
 * @returns {Object} { addresses, loading, error, fetchAddresses }
 */
export function useClientAddresses() {
  const api = useApi();
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Busca endereços do cliente pelo telefone
   * @param {string} phone - Telefone do cliente (apenas dígitos)
   * @returns {Promise<Array|null>} Lista de endereços ou null em caso de erro
   */
  const fetchAddresses = useCallback(
    async (phone) => {
      // Remove caracteres não numéricos
      const cleanPhone = String(phone || "").replace(/\D/g, "");

      if (cleanPhone.length < 10 || cleanPhone.length > 11) {
        setError("Telefone deve conter 10 ou 11 dígitos");
        setAddresses([]);
        return null;
      }

      try {
        setLoading(true);
        setError(null);

        console.log(`📍 Buscando endereços para telefone: ${cleanPhone}`);

        const response = await api.get(
          `/clients/addresses/contact/${cleanPhone}`
        );

        console.log("📦 Resposta da busca de endereços:", response);
        console.log("📦 response.data:", response?.data);
        console.log("📦 É array?", Array.isArray(response?.data));

        // Estrutura esperada da resposta: { data: [...] }
        const addressList = response?.data || [];

        console.log("📋 Lista final de endereços:", addressList);
        console.log("📋 Quantidade:", addressList.length);

        setAddresses(addressList);

        return addressList;
      } catch (err) {
        console.error("❌ Erro ao buscar endereços:", err);
        const errorMessage =
          err?.response?.data?.message ||
          err?.message ||
          "Não foi possível buscar os endereços";
        setError(errorMessage);
        setAddresses([]);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  /**
   * Limpa a lista de endereços
   */
  const clearAddresses = useCallback(() => {
    setAddresses([]);
    setError(null);
    setLoading(false);
  }, []);

  return {
    addresses,
    loading,
    error,
    fetchAddresses,
    clearAddresses,
  };
}
